import { ReactNode } from 'react';

export enum EActivity {
  COMMENTS = 'Comments',
  HISTORY = 'History',
  TRANSITIONS = 'Transitions',
}

export interface IUseActivity {
  activity: ReactNode;
  activityType: EActivity;
  onActivityTypeChange: (value: string) => void;
}

export type ActivityTypeMap = {
  [key in EActivity]?: ReactNode;
};
